@if (visible()) {
  <div
    #bannerRoot
    class="w-full border-b border-amber-200 bg-amber-50 px-6 py-2.5 text-xs font-medium text-amber-800 md:text-sm"
    role="status"
    aria-live="polite">
    <div class="relative mx-auto flex w-full max-w-[90rem] items-center">
      <div class="flex min-w-0 flex-1 items-center justify-center gap-2 px-8 text-center sm:gap-2.5">
        <lucide-icon
          name="triangle-alert"
          [size]="16"
          class="hidden shrink-0 text-amber-600 sm:block"
          aria-hidden="true" />
        <p class="leading-snug">
          Entorno de pruebas: Los datos introducidos no son reales, son simulados y no suponen ninguna
          contratación legal ni reserva real de espacios.
        </p>
      </div>
      <button
        type="button"
        class="absolute right-0 inline-flex shrink-0 items-center justify-center rounded-md p-1 text-amber-500 transition-colors hover:text-amber-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/60"
        (click)="close()"
        aria-label="Cerrar aviso de entorno de pruebas">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="h-4 w-4"
          aria-hidden="true">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>
  </div>
}
